import api from '@/api/axios'

export const getContentPage = async (contentPage = '', section = '') => {
  const response = await api.get(`/contents/page/section?contentPage=${contentPage}&section=${section}`)
  return response.data
}

export const getNews = async (page = 1, limit = 10) => {
  const response = await api.get(`/contents/list/news?page=${page}&limit=${limit}`)
  return response.data.docs
}